import React, { useContext } from "react";
import CommunityAnalysisContext from "./contexts/CommunityAnalysis.context";
import CommunityAnalysis from "./CommunityAnalysis";
import useCommunity from "./hooks/useCommunityState.hooks";

const CommunityAnalysisContainer = () => {
  const {
    dateRange,
    setDateRange,
    highLevelDataArray,
    timeFrame,
    setTimeFrame,
  } = useCommunity();

  const value = {
    dateRange,
    setDateRange,
    highLevelDataArray,
    timeFrame,
    setTimeFrame,
  };
  return (
    <CommunityAnalysisContext.Provider value={value}>
      <CommunityAnalysis />
    </CommunityAnalysisContext.Provider>
  );
};

export default CommunityAnalysisContainer;
